const ConsentTypes = {
    SET_CONSENT: "consent/set", 
    RESET_CONSENT: "consent/reset", 
}

export default ConsentTypes;